import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {Checkin} from './checkin.types';
import {tap} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CheckinService {

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    getById(spaceId: number): Observable<Checkin> {
        return this._httpClient.get<Checkin>(`${environment.node}/inspection-checkins/${spaceId}`, {
            reportProgress: true
        }).pipe(
            tap((response: Checkin) => {
                return response;
            })
        );
    }

    create(checkin: Checkin): Observable<Checkin> {
        return this._httpClient.post<Checkin>(`${environment.node}/inspection-checkins`, checkin, {
            reportProgress: true
        }).pipe(
            tap((response: Checkin) => {
                return response;
            })
        );
    }

    update(id: number, checkin: Checkin): Observable<Checkin> {
        return this._httpClient.patch<Checkin>(`${environment.node}/inspection-checkins/${id}`, checkin, {
            reportProgress: true
        }).pipe(
            tap((response: Checkin) => {
                return response;
            })
        );
    }
}

